import {css, cx} from '@panda/css';
import {Box, BoxProps} from '@panda/jsx';

export interface SkeletonProps extends BoxProps {
	width?: string;
	height?: string;
}

export const Skeleton = ({
	width = 'full',
	height = '300px',
	className,
	...boxProps
}: SkeletonProps) => (
	<Box
		{...boxProps}
		className={cx(
			css({
				display: 'block',
				height,
				width,
				backgroundColor: 'eds.background.elevated.high.hover',
				animation: `pulse 2s ease-in-out 0.5s infinite`
			}),
			className
		)}
	/>
);
